import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-forecast',
  templateUrl: './forecast.component.html',
  styleUrls: ['./forecast.component.css']
})
export class ForecastComponent implements OnInit {
    forecastKeyno;

    public edit?: Edit;

    public selectListForecastTypes: ForecastTypeItem[] = [];

    public selectListResolutions: ResolutionItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.forecastKeyno = this.stateService.getStateParams()['forecast_keyno'];
    }

    private async loadEdit() {
        if (!!this.forecastKeyno) {
            this.edit = (await this.datatask.Post(856, { forecast_keyno: this.forecastKeyno }))[0];
        }
    }

    private async loadForecastTypes(): Promise<void> {
        this.selectListForecastTypes = await this.datatask.Post(858);
    }

    private async loadResolutions(): Promise<void> {
        this.selectListResolutions = await this.datatask.Post(857);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(859, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadForecastTypes();
        this.loadResolutions();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    forecast_keyno: number;
    forecast_name: string;
    forecast_type_id: string;
    forecast_resolution_id: string;
    forecast_forward_nbr: number;
    forecast_history_running_nbr: number;
    forecast_history_fixed_fom_date: string;
    forecast_history_fixed_tom_date: string;
    forecast_forward_text: string;
    forecast_history_text: string;
    forecast_forward_fixed_startdate: string;
}

interface ForecastTypeItem {
    forecast_type_id: string;
    forecast_type_name: string;
    orderby: number;
}

interface ResolutionItem {
    forecast_resolution_id: string;
    color_name: string;
    orderby: number;
}
